import { useMemo } from 'react'

import { useIsAffiliationsEnabled } from './use-is-affiliations-enabled'
import { useIsFeatureSettingsEnabled } from './use-is-feature-settings-enabled'
import { useIsPaymentMethodEnabled } from './use-is-payment-method-enabled'
import { useIsRecurrenceAttemptConfigEnabled } from './use-is-recurrence-attempt-config-enabled'
import { useIsRecurrenceBoletoConfigEnabled } from './use-is-recurrence-boleto-config-enabled'
import { useIsRecurrenceSettingsEnabled } from './use-is-recurrence-settings-enabled'

export function useDigitalSettingsEnabledFeatures() {
  const { isFeatureFlagEnabled: isPaymentMethodEnabled, isLoading: isPaymentMethodLoading } =
    useIsPaymentMethodEnabled()
  const { isFeatureFlagEnabled: isRecurrenceSettingsEnabled, isLoading: isRecurrenceSettingsLoading } =
    useIsRecurrenceSettingsEnabled()
  const { isFeatureFlagEnabled: isFeatureSettingsEnabled, isLoading: isFeatureSettingsLoading } =
    useIsFeatureSettingsEnabled()
  const { isFeatureFlagEnabled: isAffiliationsEnabled, isLoading: isAffiliationsLoading } = useIsAffiliationsEnabled()
  const { isFeatureFlagEnabled: isBoletoConfigEnabled, isLoading: isBoletoConfigLoading } =
    useIsRecurrenceBoletoConfigEnabled()
  const { isFeatureFlagEnabled: isAttemptConfigEnabled, isLoading: isAttemptConfigLoading } =
    useIsRecurrenceAttemptConfigEnabled()

  const isLoading = useMemo(
    () =>
      isPaymentMethodLoading ||
      isRecurrenceSettingsLoading ||
      isFeatureSettingsLoading ||
      isAffiliationsLoading ||
      isBoletoConfigLoading ||
      isAttemptConfigLoading,
    [
      isPaymentMethodLoading,
      isRecurrenceSettingsLoading,
      isFeatureSettingsLoading,
      isAffiliationsLoading,
      isBoletoConfigLoading,
      isAttemptConfigLoading
    ]
  )

  return {
    isPaymentMethodEnabled,
    isRecurrenceSettingsEnabled,
    isFeatureSettingsEnabled,
    isAffiliationsEnabled,
    isBoletoConfigEnabled,
    isAttemptConfigEnabled,
    isLoading
  }
}
